import { Button, Input, InputGroup, InputLeftElement, Modal, ModalBody, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay, Stack, Text, useDisclosure } from '@chakra-ui/react';
import React, { useEffect } from 'react';
import { addDonation, getUser } from '../store/actions';
import { useAppDispatch, useAppSelector } from '../hooks';

import { AppDispatch } from '../store';
import { ArrowForwardIcon } from '@chakra-ui/icons';
import { donationFormValidation } from '../utils';
import { donationType } from '../types';
import { useFormik } from 'formik';
import { usePaystackPayment } from 'react-paystack';

export const DonateButton = () => {

    const { isOpen, onOpen, onClose } = useDisclosure();

    const { user } = useAppSelector(state => state.userReducer);

    const dispatch: AppDispatch = useAppDispatch();

    const donationForm = useFormik({
        initialValues: {
            first_name: '',
            last_name: '',
            email: '',
            amount: 10,
            reference: ''
        },
        validationSchema: donationFormValidation,
        onSubmit: (values: donationType) => {
            handlePayment(values);
        },
    });

    const config: any = {
        firstname: String(user?.first_name),
        lastname: String(user?.last_name),
        phone: String(user?.phone),
        email: String(user?.email),
        amount: Number(`${donationForm.values.amount}00`),
        publicKey: process.env.REACT_APP_PAYSTACK_PUBLICK_KEY,
        currency: 'ZAR',
    };

    const initializePayment = usePaystackPayment(config);

    // const onSuccess = (reference: void) => {
    //     const data: any = reference;
    //     console.log(data?.reference);
    // };

    const _onClose = () => {
        console.log('');
    };

    const handlePayment = async (values: donationType) => {
        if (donationForm.isValid) {
            initializePayment((reference: void) => {
                const data: any = reference;
                donationForm.setFieldValue('reference', String(data?.reference));
                dispatch(addDonation(values));
                // console.log(data?.reference);
            }, _onClose);
        }
    };

    const setFormValues = () => {
        donationForm.setFieldValue('first_name', user?.first_name);
        donationForm.setFieldValue('last_name', user?.last_name);
        donationForm.setFieldValue('email', user?.email);
    };

    useEffect(() => {
    }, [donationForm.values]);

    useEffect(() => {
        dispatch(getUser()).then(() => setFormValues());
        setFormValues();
    }, []);

    useEffect(() => {}, []);

    return (
        <>
            <Button onClick={onOpen}>Buy us a vetkoek 🎉</Button>
            <Modal isOpen={isOpen} onClose={onClose}>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader textTransform={'capitalize'}>Donation</ModalHeader>
                    <ModalCloseButton colorScheme={'yellow'} />
                    <ModalBody mb={3}>
                        <form onSubmit={donationForm.handleSubmit}>
                            <Stack mb={3}>
                                <InputGroup>
                                    <InputLeftElement
                                        pointerEvents='none'
                                        color='gray.300'
                                        fontSize='1.2em'
                                    >
                                        R
                                    </InputLeftElement>
                                    <Input required name='amount' value={donationForm.values.amount} placeholder='Enter amount' onChange={donationForm.handleChange} />
                                    {/* <InputRightElement children={donationForm.values.amount && <CheckIcon color='green.500' />} /> */}
                                </InputGroup>
                                {donationForm.errors.amount && <Text fontSize='sm' color='red.400'>{donationForm.errors.amount}</Text>}
                            </Stack>
                            <Button w={'full'} disabled={!donationForm.isValid || donationForm.values.amount === 0} type={'submit'} colorScheme={'yellow'} rightIcon={<ArrowForwardIcon />}>Thank you</Button>
                        </form>
                    </ModalBody>
                </ModalContent>
            </Modal>
        </>
    );
};